// routes.js
import { HomeIcon, InfoIcon, PhoneIcon } from "lucide-react";

export const routes = [
  { title: "Home", href: "", Icon: HomeIcon },
  { title: "Over", href: "Over", Icon: InfoIcon },
  { title: "Kunstgalerie", href: "Kunstgalerie", Icon: InfoIcon },
  { title: "Workshops", href: "Workshops", Icon: InfoIcon },
  { title: "Contact", href: "Contact", Icon: PhoneIcon },
  { title: "FAQ", href: "faq", Icon: InfoIcon },
];
